import {combineReducers} from 'redux';

import {prescription as values} from './prescription/prescription';
import {errors} from './errors/errors';
import {shouldUpdate} from './shouldUpdate/shouldUpdate';
import {savedCustomerPrescriptions} from './savedCustomerPrescription/savedCustomerPrescription';

export const prescription = combineReducers({
    values,
    errors,
    shouldUpdate,
    savedCustomerPrescriptions,
});
